import { FC } from "react";

import IconProps from "./IconProps";

const PlusThin: FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_17206_962)">
      <path
        d="M8.49992 3.3335V12.6668M3.83325 8.00016H13.1666"
        stroke="#C4C4C4"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_17206_962">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default PlusThin;
